import React from 'react'
import { DragDropContext, Droppable, DropResult } from '@hello-pangea/dnd'
import EmptyTablePlaceholder from '../../shared/EmptyTablePlaceholder'
import { TableColumnManager } from '../../shared/TableColumnManager'
import { t } from '../../../i18n'
import { useCatalogue } from '../CatalogueProvider'
import { NAME_COLUMN, nameColumnSpan, selectableColumns, selectedColumns } from '../catalogueSelectors'
import { MAIN_DROPPABLE_ID, MAIN_DROPPABLE_TYPE } from '../catalogueOrdering'
import { ProductColumn } from '../catalogueTypes'
import { CatalogueCategoryRow, CatalogueItemRow } from './CatalogueTableRows'

const CatalogueTable = () => {
  const { state, actions } = useCatalogue()
  const { rows, columns, categoryId, rowsLoadingFor } = state

  if (categoryId === null) return null
  if (rows.length === 0) {
    return rowsLoadingFor === categoryId ? null : <EmptyTablePlaceholder heading={t('product.no_records_heading')} />
  }

  const nameSpan = nameColumnSpan(columns)

  const setAllSelected = (selected: boolean) =>
    actions.updateColumns(columns.map((column) => (column.mandatory ? column : { ...column, selected })))

  const toggleColumn = (column: ProductColumn, selected: boolean) =>
    actions.updateColumns(columns.map((entry) => (entry.column_name === column.column_name ? { ...entry, selected } : entry)))

  const handleDragEnd = (result: DropResult) => actions.reorderTableRows(categoryId, rows, result)

  return (
    <table className="table table-robis">
      <thead className="thead-robis">
        <tr>
          {selectedColumns(columns).map((column) => (
            <th colSpan={column.column_name === NAME_COLUMN ? nameSpan : 1} className={column.column_name} key={column.column_label}>
              {column.column_label}
            </th>
          ))}
          <TableColumnManager
            possibleColumns={selectableColumns(columns)}
            selectAll={() => setAllSelected(true)}
            clearAll={() => setAllSelected(false)}
            updatePositions={actions.updateColumns}
            handleSettingChange={toggleColumn}
          />
        </tr>
      </thead>
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId={MAIN_DROPPABLE_ID} type={MAIN_DROPPABLE_TYPE}>
          {(provided) => (
            <tbody {...provided.droppableProps} ref={provided.innerRef}>
              {rows.map((row, index) =>
                row.class_name === 'ProductCategory' ? (
                  <CatalogueCategoryRow key={`ProductCategory-${row.id}`} category={row} index={index} />
                ) : (
                  <CatalogueItemRow key={`Product-${row.id}`} item={row} index={index} draggableId={`Product-${row.id}`} className="" />
                )
              )}
              {provided.placeholder}
            </tbody>
          )}
        </Droppable>
      </DragDropContext>
    </table>
  )
}

export default CatalogueTable
